<template>
  <transition
      enter-active-class="transition-all duration-300 ease-out"
      leave-active-class="transition-all duration-200 ease-in"
      enter-class="opacity-0 scale-95"
      enter-to-class="opacity-100 scale-100"
      leave-class="opacity-100 scale-100"
      leave-to-class="opacity-0 scale-95"
  >
    <div
        v-if="confirmModal.visible"
        class="fixed inset-0 z-[999] flex items-center justify-center bg-black/70 backdrop-blur-xl p-4"
        dir="rtl"
        @click.self="$emit('close')"
    >
      <div
          class="w-full max-w-md rounded-3xl border border-white/10 bg-slate-950/95 shadow-2xl shadow-black/70 overflow-hidden"
      >
        <div class="p-5 border-b border-white/10" :class="confirmTheme.headerBg">
          <div class="flex items-start gap-3">
            <div
                class="w-11 h-11 rounded-2xl border flex items-center justify-center shrink-0"
                :class="confirmTheme.iconBox"
            >
              <svg class="w-5 h-5" :class="confirmTheme.icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path
                    v-if="confirmModal.toStatus === 'cf'"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M5 13l4 4L19 7"
                />
                <path
                    v-else-if="confirmModal.toStatus === 'ca'"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M6 18L18 6M6 6l12 12"
                />
                <path
                    v-else
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M3 10h10a8 8 0 018 8v2M3 10l6 6m-6-6l6-6"
                />
              </svg>
            </div>

            <div class="min-w-0 flex-1">
              <div class="text-[11px] text-slate-400">تأیید تغییر وضعیت</div>

              <div class="mt-1 text-base font-black text-slate-50">
                {{ confirmModal.title }}
              </div>

              <div class="mt-1 text-xs leading-6" :class="confirmTheme.subtitle">
                {{ confirmModal.subtitle }}
              </div>
            </div>
          </div>

          <div class="mt-4 rounded-2xl border border-white/10 bg-slate-950/40 px-3 py-2 text-[11px] text-slate-400">
            Enter = اجرای گزینه انتخاب‌شده،
            ↑↓ = جابه‌جایی،
            Esc = انصراف
          </div>
        </div>

        <div class="p-5 space-y-4">
          <div class="rounded-2xl bg-slate-900/70 border border-white/10 p-4">
            <div class="text-[11px] text-slate-400 mb-3">با انجام این کار:</div>

            <ul class="space-y-2 text-sm text-slate-200">
              <li
                  v-for="(b, idx) in confirmModal.bullets"
                  :key="idx"
                  class="flex items-start gap-2"
              >
                <span class="mt-2 w-1.5 h-1.5 rounded-full shrink-0" :class="confirmTheme.dot"></span>
                <span class="leading-6">{{ b }}</span>
              </li>
            </ul>
          </div>

          <div
              v-if="confirmModal.toStatus === 'cf'"
              class="rounded-2xl border border-emerald-400/20 bg-emerald-500/10 p-3 text-xs leading-6 text-emerald-100"
          >
            بعد از نهایی‌سازی موفق، فاکتور چاپ به‌صورت خودکار باز می‌شود.
          </div>

          <div class="grid grid-cols-2 gap-3">
            <button
                type="button"
                @click="$emit('close')"
                :disabled="confirmModal.loading"
                class="px-4 py-3 rounded-2xl bg-slate-800 text-slate-200 hover:bg-slate-700 border text-sm font-bold transition-all duration-200 disabled:opacity-60 disabled:cursor-not-allowed text-center"
                :class="confirmKeyboardAction === 'cancel'
                  ? 'border-slate-300 ring-2 ring-slate-300/30 scale-[1.02]'
                  : 'border-white/10'"
            >
              انصراف
            </button>

            <button
                type="button"
                @click="$emit('confirm')"
                :disabled="confirmModal.loading"
                class="px-4 py-3 rounded-2xl text-slate-950 text-sm font-black transition-all duration-200 active:scale-95 disabled:opacity-60 disabled:cursor-not-allowed text-center"
                :class="[
                  confirmTheme.confirmBtn,
                  confirmKeyboardAction === 'confirm'
                    ? 'ring-2 ring-white/40 scale-[1.02]'
                    : ''
                ]"
            >
              {{ confirmModal.loading ? 'در حال انجام...' : confirmModal.confirmText }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'PosConfirmStatusModal',

  props: {
    confirmModal: {
      type: Object,
      required: true
    },
    confirmTheme: {
      type: Object,
      required: true
    },
    confirmKeyboardAction: {
      type: String,
      default: 'confirm'
    }
  }
}
</script>